module.exports = __webpack_public_path__ + "img/LOGO_DARK_MODE.afc546f1.png";